import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import AppInitializer from "./AppInitializer";
import { FeedbackProvider } from "./providers/FeedbackProvider";
import AnalyticsPageTracker from "./components/AnalyticsPageTracker";

function App() {
  
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <FeedbackProvider>
          <AppInitializer>
            <AnalyticsPageTracker />
            <AppRoutes />
          </AppInitializer>
        </FeedbackProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
